import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-terms-and-conditions-component',
    templateUrl: './termsandconditions.component.html',
    styles: [`
                body {
                    font-size: 18px;
                    font-weight: 600;
                }
            `]
})

export class TermsAndConditionsComponent { }
